import React from 'react';
import { _ } from "@/pages/_app";
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import QuoteIcon from './icons/QuoteIcon';

interface Testimonial {
  text: string;
  author: string;
  title: string;
  image: string;
}

const TestimonialsSection = () => {
  const testimonials: Testimonial[] = [
    {
      text: _("testimonial-message_1"),
      author: "Vibeke Thoresen",
      title: _("testimonial-message_1-author-position"),
      image: "https://cdn.prod.website-files.com/628ee7154f9e73649ec45f21/691c39776d29568f717b44ae_vibeke.png"
    },
    {
      text: _("testimonial-message_2"),
      author: "Johanne Ellgaard",
      title: _("testimonial-message_2-author-position"),
      image: "https://cdn.prod.website-files.com/628ee7154f9e73649ec45f21/691c3977814b96d2fbddeb9e_johanne.png"
    },
    {
      text: _("testimonial-message_3"),
      author: "Sabina Svärd",
      title: _("testimonial-message_3-author-position"),
      image: "https://cdn.prod.website-files.com/628ee7154f9e73649ec45f21/691c39774956d9e24bf2d07b_sabina.png"
    }
  ];

  const renderTestimonial = (testimonial: Testimonial) => (
    <div className="flex flex-col bg-[#d6a471] rounded-[1.4rem] sm:rounded-[1.8rem] w-full p-[1.5rem] sm:p-[2rem]">
      <div className="w-[2.4rem] sm:w-[3.2rem] h-auto mb-[1.4rem] sm:mb-[2.3rem]">
        <QuoteIcon />
      </div>
      <p className="text-[#0e0c0b] text-left mb-[1.2rem] font-poppins text-[0.95rem] sm:text-[1.1rem] font-normal leading-[1.6rem] sm:leading-[1.9rem] whitespace-pre-line">
        {testimonial.text}
      </p>
      <div className="flex flex-row gap-[1rem] justify-start items-center w-full mt-[0.5rem]">
        <img
          src={testimonial.image}
          alt={testimonial.author}
          className="w-14 sm:w-20 h-14 sm:h-20 rounded-full object-cover"
        />
        <div className="flex flex-col gap-[0.1rem] sm:gap-[0.25rem] w-full">
          <p className="text-[#1b1817] text-left max-w-[90%] font-poppins text-[0.95rem] sm:text-[1.1rem] font-semibold leading-[1.7rem]">
            {testimonial.author}
          </p>
          <p className="text-[#513425] text-left max-w-[90%] font-poppins text-[0.85rem] sm:text-[0.9rem] font-normal leading-[1.3rem]">
            {testimonial.title}
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <section className="relative z-[99] bg-[#c49665] bg-gradient-to-b from-[#e4c099] to-[#d3a573] rounded-br-[2rem] sm:rounded-br-[4rem] rounded-bl-[2rem] sm:rounded-bl-[4rem] flex justify-center items-center pt-[2.8rem] pb-[3.2rem] sm:pt-[4rem] sm:pb-[4rem] md:pt-[8rem] md:pb-[8rem] top-0 shadow-[0_0_32px_rgba(0,0,0,0.1)]">
      <div className="absolute top-0 -translate-y-full w-full h-[4rem] bg-[#E4BF99]"></div>
      <div className="max-w-[1360px] px-5 w-full">
        <div className="flex flex-col justify-center items-center gap-[1.5rem] sm:gap-[2.4rem] md:gap-[3.2rem]">
          <h2 className="text-center text-[2rem] sm:text-[2.4rem] md:text-[3.2rem] leading-[2.4rem] sm:leading-[2.8rem] md:leading-[3.6rem] mb-0 font-poppins font-semibold">
            {_("checkout-testimonials_title")}
          </h2>

          {/* DESKTOP: Flex Grid */}
          <div className="hidden lg:flex flex-row gap-[2rem] items-stretch mb-4 w-full">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="w-full">
                {renderTestimonial(testimonial)}
              </div>
            ))}
          </div>

          {/* MOBILE: Swiper */}
          <div className="block lg:hidden w-full">
            <Swiper
              modules={[FreeMode]}
              spaceBetween={20}
              slidesPerView="auto"
              freeMode={true}
              className="!overflow-visible"
            >
              {testimonials.map((testimonial, index) => (
                <SwiperSlide key={index} className="!w-[20rem]">
                  {renderTestimonial(testimonial)}
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;